import React from "react";
import { GlyphTriangle } from "@vx/glyph";
import { Circle } from "@vx/shape";
import { Group } from "@vx/group";

// returns svg element for arrow element in Bird eye view

export default function ArrowObject({
  top,
  left,
  fill,
  length,
  rotation,
  selectedObject,
  ...rest
}) {
  return (
    <Group
      transform={`translate(${left} ${top}) rotate(${rotation})`}
      {...rest}
    >
      <GlyphTriangle top={-length - 9} stroke={fill} fill={fill} />
      <line stroke={fill} x1={0} x2={0} y1={-5} y2={-length - 5} />
      <Circle
        r={5}
        fill={fill}
        stroke={
          selectedObject && selectedObject.type === "lka"
            ? "#39ff14"
            : "transparent"
        }
        strokeWidth="2"
      />
    </Group>
  );
}

